import React from "react";
import { useDroppable } from "@dnd-kit/core";
import CrmCard from "./CrmCard";
import { START_COLUMN, delayHours, timing, fmtEuro, plural, rgba } from "./crmUtils";

function Footer({ col, cards, state, now }) {
  if (col.won) {
    const clients = cards.filter((c) => c.client);
    const total = clients.reduce((s, c) => s + (Number(c.client.price) || 0), 0);
    const ms = new Date(); ms.setDate(1); ms.setHours(0, 0, 0, 0);
    const signed = clients.filter((c) => c.client.signedAt && Date.parse(c.client.signedAt) >= ms.getTime()).reduce((s, c) => s + (Number(c.client.price) || 0), 0);
    return (
      <div className="space-y-0.5 text-xs">
        <p><strong>{plural(clients.length, "client")}</strong> <span className="text-ink-muted">· total :</span> <strong>{fmtEuro(total)}</strong></p>
        <p><span className="text-ink-muted">CA signé ce mois :</span> <strong>{fmtEuro(signed)}</strong></p>
      </div>
    );
  }
  if (col.todo) return <p className="text-xs"><strong>{cards.length}</strong> <span className="text-ink-muted">·</span> <span className={cards.length ? "font-bold text-bordeaux" : "text-ink-muted"}>{plural(cards.length, "relance")} à faire</span></p>;
  if (delayHours(state, col.id) === null) return <p className="text-xs font-semibold">{cards.length}</p>;
  if (col.autoTo) return <p className="text-xs font-semibold">{cards.length}</p>;
  const late = cards.filter((c) => timing(state, c, now).overdue).length;
  const stale = col.overdueKind === "stale";
  return <p className="text-xs"><strong title={plural(cards.length, "carte")}>{cards.length}</strong> <span className="text-ink-muted">·</span> <span className={stale ? "font-semibold text-ink-soft" : late ? "font-bold text-bordeaux" : "text-ink-muted"}>{late} {stale ? "sans réponse" : "à relancer"}</span></p>;
}

export default function CrmColumn({ col, state, q, ro, update, onOpen, onNew, now }) {
  const { setNodeRef, isOver: over } = useDroppable({ id: col.id, disabled: ro });
  const all = state.cards.filter((c) => c.column === col.id);
  const timed = delayHours(state, col.id) !== null;
  const sorted = [...all].sort((a, b) => (timed ? timing(state, a, now).deadline - timing(state, b, now).deadline : Date.parse(b.enteredAt) - Date.parse(a.enteredAt)));
  const visible = sorted.filter(q);
  return (
    <section ref={setNodeRef} data-testid={`crm-col-${col.id}`}
      className="flex max-h-[calc(100vh-260px)] min-h-[420px] w-[84vw] shrink-0 flex-col overflow-hidden rounded-[20px] border border-line transition-shadow sm:w-[290px]"
      style={{ background: rgba(col.color, over ? 0.12 : 0.05), boxShadow: over ? `0 0 0 2px ${col.color}` : undefined }}>
      <div className="h-1 shrink-0" style={{ background: col.color }} />
      <header className="shrink-0 px-3 pb-2 pt-3">
        <p className="flex items-center gap-2 text-[13px] font-semibold text-ink"><span className="h-2 w-2 rounded-full" style={{ background: col.color }} />{col.title}</p>
        <p className="mt-1 text-[11.5px] leading-snug text-ink-muted">{col.desc}</p>
        {col.id === START_COLUMN && !ro && <button data-testid="crm-new" onClick={onNew} className="mt-3 w-full rounded-lg border border-dashed bg-white py-1.5 text-xs font-medium transition-colors hover:bg-bordeaux-tint/40" style={{ borderColor: col.color, color: "#7B113A" }}>+ Nouveau prospect</button>}
      </header>
      <div className="flex min-h-[60px] flex-1 flex-col gap-2 overflow-y-auto px-2.5 pb-3 pt-1">
        {visible.length ? visible.map((c) => <CrmCard key={c.id} card={c} state={state} ro={ro} update={update} onOpen={onOpen} now={now} />)
          : <p className="py-4 text-center text-xs text-ink-muted">{all.length ? "Aucun résultat" : "Aucune carte"}</p>}
      </div>
      <footer className="shrink-0 border-t border-line bg-white/70 px-3 py-2.5"><Footer col={col} cards={all} state={state} now={now} /></footer>
    </section>
  );
}
